import { Avatar, Box, Flex, Stack, Text } from '@elkaso-app/web-design';

interface IUserInfo {
  name: string;
  email: string;
  phoneNumber: string;
}

export const AccountInfo = ({ name, email, phoneNumber }: IUserInfo) => {
  return (
    <Flex align='center'>
      <Box>
        <Avatar name={name} size='lg' bg='red.500' color='white' />
      </Box>

      <Stack spacing='xs' ms='md' color='black'>
        <Text fontWeight='bold' fontSize='md'>
          {name}
        </Text>
        <Text>{email}</Text>
        <Text>{phoneNumber}</Text>
      </Stack>
    </Flex>
  );
};
